import { colors as tokens } from "@zapalacorp/tokens";

/**
 * DumontSidebar Color Palette
 * Mapeia cores hardcoded para tokens do sistema quando possível
 * Cores específicas do Dumont que não existem no @zapalacorp/tokens são mantidas como constantes
 */
export const dumontColors = {
  // Brand colors - Dumont specific (não existem no @zapalacorp/tokens)
  primary: "#00A49F", // Teal principal do Dumont
  primaryHover: "#00918D", // Teal hover
  primaryLight: "rgba(0, 164, 159, 0.1)", // Teal light background

  // Neutral colors - mapeados para @zapalacorp/tokens
  white: tokens.white,
  black: tokens.black,

  // Gray scale
  gray50: tokens.gray50, // #F9FAFB
  gray100: tokens.gray100, // #F2F4F7
  gray200: tokens.gray200, // #EAECF0
  gray300: tokens.gray300, // #D0D5DD
  gray400: tokens.gray400, // #98A2B3
  gray500: tokens.gray500, // #667085
  gray600: tokens.gray600, // #475467
  gray700: tokens.gray700, // #344054
  gray800: tokens.gray800, // #1D2939
  gray900: tokens.gray900, // #101828

  // Specific mappings for common use cases
  border: tokens.gray200, // #EAECF0 (was #E5E7EB, #EBEBEB)
  borderLight: tokens.gray100, // #F2F4F7
  background: tokens.gray50, // #F9FAFB (was #FCFCFD)
  backgroundHover: tokens.gray50, // #F9FAFB
  hoverBackground: "#EFEFEF", // Specific hover color for Dumont (não existe em @zapalacorp/tokens)
  text: tokens.gray800, // #1D2939
  textSecondary: tokens.gray600, // #475467
  textTertiary: tokens.gray500, // #667085
  textDisabled: tokens.gray400, // #98A2B3
  placeholder: tokens.gray500, // #667085

  // Status colors
  success: tokens.success500,
  error: tokens.error500,
  warning: tokens.warning500,

  // Shadow
  shadow: "rgba(2, 131, 128, 0.15)",
} as const;

export type DumontColor = keyof typeof dumontColors;
